/* eslint-disable max-len */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const navigation = (
  badgeMap: Record<string, string>,
  currentAccount: any,
  isFlagOn: (key: string, def?: boolean) => boolean = () => true
): FuseNavigationItem[] => {
  const navigationMenu: FuseNavigationItem[] = [
    // {
    //   id: "main",
    //   title: "",
    //   type: "group",
    //   children: [
    //     {
    //       id: "dashboard",
    //       title: "Dashboard",
    //       type: "basic",
    //       icon: "taskezy:te_web_dashboard",
    //       link: "/pages/home"
    //     }
    //   ]
    // },
    {
      id: "activities",
      title: "shell.nav.activities",
      type: "group",
      children: [
        {
          id: "roster",
          title: "shell.nav.roster",
          type: "basic",
          icon: "taskezy:te_web_roster",
          link: "/pages/roster",
          ...(badgeMap["roster"] && badgeMap["roster"] !== "0"
            ? {
                badge: {
                  title: badgeMap["roster"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
        },
        {
          id: "attendance-register",
          title: "shell.nav.attendanceRegister",
          type: "basic",
          icon: "taskezy:te_web_attendance",
          link: "/pages/attendance-register",
          hidden: () => (currentAccount?.isSubscriber ? false : true)
        }
        // {
        //   id: "register",
        //   title: "Timesheet Register",
        //   type: "basic",
        //   icon: "taskezy:te_web_timesheet-register",
        //   link: "/pages/timesheet-register",
        //   ...(badgeMap["timesheet-register"] &&
        //   badgeMap["timesheet-register"] !== "0"
        //     ? {
        //         badge: {
        //           title: badgeMap["timesheet-register"],
        //           classes: "w-5 h-5 bg-primary text-white rounded-full"
        //         }
        //       }
        //     : {}),
        //   hidden: () => (currentAccount?.isSubscriber ? false : true)
        // }
        // {
        //   id: "reporting",
        //   title: "Incident Reporting",
        //   type: "basic",
        //   icon: "taskezy:",
        //   link: "/pages/",
        //   hidden: () => true
        // },
        // {
        //   id: "interviews-onboarding",
        //   title: "Interviews and Onboarding",
        //   type: "basic",
        //   icon: "taskezy:",
        //   link: "/pages/",
        //   hidden: () => true
        // },
        // {
        //   id: "performance-management",
        //   title: "Performance Management",
        //   type: "basic",
        //   icon: "taskezy:",
        //   link: "/pages/",
        //   hidden: () => true
        // },
        // {
        //   id: "template-library",
        //   title: "Template Library",
        //   type: "basic",
        //   icon: "taskezy:",
        //   link: "/pages/",
        //   hidden: () => true
        // }
      ]
    },
    {
      id: "reports",
      title: "shell.nav.reports",
      type: "group",
      children: [
        {
          id: "sign-on-off-registers",
          title: "shell.nav.signOnOffRegisters",
          type: "basic",
          icon: "taskezy:te_web_timesheet-register",
          link: "/pages/sign-on-sign-off-register"
        },
        {
          id: "incident-reports",
          title: "shell.nav.incidentReports",
          type: "basic",
          icon: "taskezy:te_web_incident-report",
          link: "/pages/incident-reporting",
          ...(badgeMap["incident-reports"] &&
          badgeMap["incident-reports"] !== "0"
            ? {
                badge: {
                  title: badgeMap["incident-reports"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
        }
        // {
        //   id: "assesments",
        //   title: "Assessments",
        //   type: "basic",
        //   icon: "taskezy:",
        //   link: "/pages/",
        //   hidden: () => true
        // },
        // {
        //   id: "end-of-shift-reports",
        //   title: "End of Shift Reports",
        //   type: "basic",
        //   icon: "taskezy:",
        //   link: "/pages/",
        //   hidden: () => true
        // },
        // {
        //   id: "other-custom-reports",
        //   title: "Other Custom Reports",
        //   type: "basic",
        //   icon: "taskezy:",
        //   link: "/pages/",
        //   hidden: () => true
        // }
      ]
    },
    {
      id: "network",
      title: "shell.nav.network",
      type: "group",
      children: [
        // {
        //   id: "clients",
        //   title: "Clients",
        //   icon: "taskezy:te_web_clients",
        //   type: "basic",
        //   link: "/pages/list-clients",
        //   ...(badgeMap["clients"] && badgeMap["clients"] !== "0"
        //     ? {
        //       badge: {
        //         title: badgeMap["clients"],
        //         classes: "w-5 h-5 bg-primary text-white rounded-full"
        //       }
        //     }
        //     : {}),
        //   hidden: () =>
        //     currentAccount?.isSubscriber || currentAccount?.isSupplier
        //       ? false
        //       : true
        // },
        {
          id: "list-venues",
          title: "shell.nav.venues",
          icon: "taskezy:te_web_venue",
          type: "basic",
          link: "/pages/list-venues",
          hidden: () => {
            console.log(
              "is supplier ",
              currentAccount?.isSubscriber,
              currentAccount?.isClient,
              currentAccount?.isSupplier
            );
            return currentAccount?.isSubscriber || currentAccount?.isClient
              ? false
              : true;
          }
        },
        // {
        //   id: "suppliers",
        //   title: "Suppliers",
        //   icon: "taskezy:te_web_supplier",
        //   type: "basic",
        //   link: "/pages/list-suppliers",
        //   ...(badgeMap["suppliers"] && badgeMap["suppliers"] !== "0"
        //     ? {
        //       badge: {
        //         title: badgeMap["suppliers"],
        //         classes: "w-5 h-5 bg-primary text-white rounded-full"
        //       }
        //     }
        //     : {}),
        //   hidden: () =>
        //     currentAccount?.isSubscriber || currentAccount?.isClient
        //       ? false
        //       : true
        // },
        {
          id: "resources",
          title: "shell.nav.resources",
          icon: "taskezy:te_web_resource",
          type: "basic",
          link: "/pages/list-resources",
          ...(!isFlagOn("is-rosterezy", false) &&
          badgeMap["resources"] &&
          badgeMap["resources"] !== "0"
            ? {
                badge: {
                  title: badgeMap["resources"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
          // hidden: () => currentAccount?.isSubscriber || currentAccount?.isSupplier ? false : true
        }
      ]
    },
    // {
    //   id       : 'templates',
    //   title    : 'TEMPLATES',
    //   type     : 'group',
    //   children : [
    //     {
    //       id             : 'interviews',
    //       title          : 'Interviews',
    //       type           : 'basic',
    //       icon           : 'taskezy:te_web_Interviews',
    //       link            : '/pages/interviews',
    //     },
    //     // {
    //     //   id:  'forms',
    //     //   title: 'Forms',
    //     //   icon: 'business_center',
    //     //   type: 'basic',
    //     //   link: '/pages/forms'
    //     // },
    //   ]
    // },
    {
      id: "account",
      title: "shell.nav.account",
      type: "group",
      children: [
        {
          id: "details",
          title: "shell.nav.details",
          type: "basic",
          icon: "taskezy:te_web_Details",
          link: "/pages/details",
          ...(badgeMap["account-details"] && badgeMap["account-details"] !== "0"
            ? {
                badge: {
                  title: badgeMap["account-details"],
                  classes: "w-5 h-5 bg-primary text-white rounded-full"
                }
              }
            : {})
        },
        {
          id: "members",
          title: "shell.nav.members",
          type: "basic",
          icon: "taskezy:te_web_members",
          link: "/pages/list-members"
        },
        {
          id: "asset-library",
          title: "shell.nav.assetLibrary",
          type: "basic",
          icon: "taskezy:te_web_asset_library",
          link: "/pages/asset-library",
          hidden: () => !isFlagOn("accreditations-available", false)
        },
        {
          id: "accreditation-register",
          title: "shell.nav.accreditations",
          type: "basic",
          icon: "taskezy:te_web_asset_library",
          link: "/pages/accreditation-v2/register",
          hidden: () => !isFlagOn("accreditations-available", false)
        }
        // {
        //   id: "audit-log",
        //   title: "Logs",
        //   type: "basic",
        //   icon: "taskezy:te_web_logs",
        //   link: "/pages/audit-log"
        // }
        //   ]
        // },
        // {
        // id       : 'others',
        // type     : 'group',
        // children : [
        // {
        //   id             : 'swap-profile',
        //   title          : 'Swap Profile',
        //   type           : 'basic',
        //   icon           : 'swap_horiz',
        //   link            : '/pages/my-profiles'
        // },
        // {
        //    id            : 'resource-pool',
        //    title         : 'Resource Pool',
        //    type          : 'basic',
        //    icon          : 'assignment_ind',
        //    link          : '/pages/resource-pool'
        // }
      ]
    }
  ];
  return navigationMenu;
};
